export default __webpack_public_path__ + "static/media/admin-bg2.a83d0e4f.jpg";